/* Medicus — says what is already included, before anyone pays for it again
   5 September 2026

   THE PROBLEM, IN A CUSTOMER'S WORDS
   "The 'artery embroidered scrub cap' doesnt actually come with the artery
   embroidered. It is extra to get that." — a one-star review. It was wrong,
   the design is included, but nothing on the page said so. Further down the
   same page sits a paid option reading "1x Embroidery (+£9)", and the two
   read as the same thing.

   WHAT THIS DOES
   On a listing whose design is stitched in as part of the price, three small
   edits, all copy:

     1. a line under the price saying the design is included;
     2. the YMQ HTML block above the placement and size controls, which today
        reads "Pre Designed Embrodiery Placement", becomes a plain heading for
        the controls beneath it;
     3. the paid image option becomes "another" logo, but only on these
        listings, because everywhere else it is the first one.

   It reads no option values, selects nothing and changes no price. Every
   string lives in the JSON in snippets/mc-included.liquid.

   LOOP SAFETY. The observer watches document.body because YMQ re-renders its
   column. Every write is guarded by a marker attribute, so a pass that has
   already run writes nothing on the next one. */
(function () {
  'use strict';

  var cfgNode = document.querySelector('script[data-mc-included-config]');
  if (!cfgNode) return;
  var cfg;
  try { cfg = JSON.parse(cfgNode.textContent); } catch (e) { return; }
  if (!cfg || !cfg.copy) return;

  var c = cfg.copy;
  var INCLUDED_BLOCK = /pre[\s-]?design/i;   /* "Pre Designed", "Pre-Designed", and the live typo */

  function all(sel, root) { return [].slice.call((root || document).querySelectorAll(sel)); }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  /* The HTML block YMQ shows above the included design's own controls. Its
     text is the only reliable signature: the option ids differ per set. */
  function includedBlock() {
    var boxes = all('.ymq-options-box[ymq-option-type="11"]');
    for (var i = 0; i < boxes.length; i++) {
      if (INCLUDED_BLOCK.test(boxes[i].textContent || '')) return boxes[i];
    }
    return null;
  }

  /* Which design this listing includes, in the words for this product. */
  function designLabel() {
    var t = (document.title || '') + ' ' + location.pathname;
    var list = cfg.designs || [];
    for (var i = 0; i < list.length; i++) {
      try { if (new RegExp(list[i].match, 'i').test(t)) return list[i].label; }
      catch (e) { /* a bad pattern must not cost the default */ }
    }
    return c.included_default;
  }

  /* The product's own price, not a related product's. The add-to-cart form is
     the anchor: walk up until a container holds a .price, then take the first
     one inside it. */
  function priceNode() {
    var form = document.querySelector('form[action*="/cart/add"]');
    var node = form;
    for (var i = 0; node && i < 8; i++) {
      var p = node.querySelector('.price, .product__price');
      if (p && (p.textContent || '').trim()) return p;
      node = node.parentElement;
    }
    return null;
  }

  function addBadge() {
    if (document.querySelector('.mc-inc__badge')) return;
    var p = priceNode();
    if (!p) return;
    var badge = el('p', 'mc-inc__badge', designLabel());
    var anchor = p.closest('.price, .product__price') || p;
    anchor.parentNode.insertBefore(badge, anchor.nextSibling);
  }

  /* Guarded on what is in the block, not on a marker: YMQ re-renders its
     column and can put its own text back inside a node we have already
     marked. A content check re-applies in that case and writes nothing when
     our copy is already there, so the observer settles after one pass. */
  function rewriteBlock(box) {
    if (box.querySelector('.mc-inc__lead')) return;
    var body = box.querySelector('.ymq-option-header') || box;
    var wrap = el('div', 'mc-inc__lead');
    wrap.appendChild(el('h3', 'mc-inc__leadhead', c.controls_heading));
    wrap.appendChild(el('p', 'mc-inc__leadtext', c.controls_text));
    body.innerHTML = '';
    body.appendChild(wrap);
  }

  /* "Add another logo or image" only reads correctly where one is already on
     the cap, so the paid option is relabelled here and nowhere else. */
  function relabelPaid() {
    var boxes = all('.ymq-options-box');
    for (var i = 0; i < boxes.length; i++) {
      var b = boxes[i];
      var lab = b.getAttribute('ymq-option-label') || '';
      if (!/image|vector|logo/i.test(lab)) continue;
      if (!all('input[ymq-option-value-id]', b).some(function (inp) { return /embroidery|vinyl/i.test(inp.value); })) continue;
      var head = b.querySelector('.ymq-option-title, .ymq_lable');
      if (!head) continue;
      var name = head.querySelector('.ymq-option-title-name') || head;
      if ((name.textContent || '').trim() === c.paid_heading) continue;   /* already ours: write nothing */
      name.textContent = c.paid_heading;
    }
  }

  /* Once a page has been recognised it stays recognised. The signature lives
     in the very block we rewrite, so after the first pass it is gone, and the
     paid option still has to be kept relabelled through YMQ's re-renders. */
  function apply() {
    var box = includedBlock();
    var known = document.documentElement.classList.contains('mc-inc-on');
    if (!box && !known) return;             /* not one of these listings */
    if (!known) document.documentElement.classList.add('mc-inc-on');
    addBadge();
    if (box) rewriteBlock(box);
    relabelPaid();
  }

  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; apply(); }, 150);   /* not rAF: frozen in a background tab */
  }

  function start() {
    apply();
    try { new MutationObserver(queue).observe(document.body, { childList: true, subtree: true }); }
    catch (e) { /* one pass is better than none */ }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
}());
